"use strict";
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.stripSpacesAndDashes = exports.getPredictedFinalBalanceState = exports.getNegative = exports.getErrorCode = exports.withOrdinal = exports.stripSpaces = exports.getDefaultAmount = exports.getCurrency = exports.formatSmart2DPNoCurrency = exports.formatAsPence = exports.createCardPaymentUrl = exports.hasDecimalPlaces = void 0;
var core_1 = require("../../../shared/core");
var constants_1 = require("../constants");
var formatAsPence = function (amount) {
    var _a = __read("".concat(amount, ".00").split('.'), 2), pounds = _a[0], pence = _a[1];
    return Number(pounds) * 100 + Number(pence);
};
exports.formatAsPence = formatAsPence;
var getDefaultAmount = function (amountFromParams) {
    if (!amountFromParams) {
        return '';
    }
    var num = Number(amountFromParams);
    return !isNaN(num) && num > 0 ? formatSmart2DPNoCurrency(num) : '';
};
exports.getDefaultAmount = getDefaultAmount;
var createCardPaymentUrl = function (amount, _a, statusRoute) {
    var redirectUrl = _a.redirectUrl, transactionReference = _a.transactionReference;
    var hostname = window.location.origin;
    var query = "?amount=".concat(Number(amount).toFixed(2), "&txId=").concat(transactionReference);
    var baseUrl = "".concat(hostname).concat(statusRoute).concat(query);
    // Assumes redirectUrl already contains a "?".
    var fullRedirectUrl = redirectUrl.concat("&successURL=".concat(encodeURIComponent("".concat(baseUrl, "&status=success"))), "&cancelURL=".concat(encodeURIComponent("".concat(baseUrl, "&status=cancelled"))), "&pendingURL=".concat(encodeURIComponent("".concat(baseUrl, "&status=pending"))), "&failureURL=".concat(encodeURIComponent("".concat(baseUrl, "&status=error"))), "&errorURL=".concat(encodeURIComponent("".concat(baseUrl, "&status=error"))));
    return fullRedirectUrl;
};
exports.createCardPaymentUrl = createCardPaymentUrl;
var getCurrency = function (currencyCode) {
    var currencyCodeUppercase = currencyCode.toUpperCase();
    switch (currencyCodeUppercase) {
        case 'AUD':
        case 'AUX':
            return { code: 'AUD', symbol: '$' };
        case 'USD':
        case 'USX':
            return { code: 'USD', symbol: '$' };
        case 'EUR':
        case 'EUX':
            return { code: 'EUR', symbol: '€' };
        default:
            return { code: 'GBP', symbol: '£' };
    }
};
exports.getCurrency = getCurrency;
var stripSpaces = function (value) { return value.replace(/\s/g, ''); };
exports.stripSpaces = stripSpaces;
var ordinal = function (value) {
    if (value > 3 && value < 21) {
        return 'th';
    }
    switch (value % 10) {
        case 1:
            return 'st';
        case 2:
            return 'nd';
        case 3:
            return 'rd';
        default:
            return 'th';
    }
};
var withOrdinal = function (value) {
    return Number.isNaN(Number(value)) ? '' : value + ordinal(Number(value));
};
exports.withOrdinal = withOrdinal;
var hasDecimalPlaces = function (num) { return num % 1 != 0; };
exports.hasDecimalPlaces = hasDecimalPlaces;
// different from currency tools - only cares about number, not currency
var formatSmart2DPNoCurrency = function (num) {
    return (0, exports.hasDecimalPlaces)(num) ? num.toFixed(2) : num.toString();
};
exports.formatSmart2DPNoCurrency = formatSmart2DPNoCurrency;
var getErrorCode = function (paymentDetails) {
    var retailer = core_1.configService.getConfig().retailer;
    if (retailer.region !== 'AUS') {
        return null;
    }
    return !paymentDetails
        ? 'GENERIC'
        : !paymentDetails.paymentSchedule
            ? 'NO_SCHEDULE'
            : paymentDetails.paymentSchedule.scheduleDay === new Date().getDate()
                ? 'SCHEDULE_DAY_TODAY'
                : !paymentDetails.hasBookedPayment
                    ? 'NO_BOOKED_PAYMENT'
                    : paymentDetails.paymentSchedule.frequency !== 'MONTHLY'
                        ? 'FREQUENCY_UNSUPPORTED'
                        : null;
};
exports.getErrorCode = getErrorCode;
var getNegative = function (num) {
    return Math.abs(num) * -1;
};
exports.getNegative = getNegative;
var getPredictedFinalBalanceState = function (amount) {
    var directDebit = core_1.configService.getConfig().directDebit;
    var balanceThresholdSmall = constants_1.BALANCE_THRESHOLD_SMALL_POSITIVE;
    var balanceThresholdLarge = constants_1.BALANCE_THRESHOLD_LARGE_POSITIVE;
    var configBalanceThresholdSmallPositive = directDebit && parseInt(directDebit.balanceThresholdSmallPositive, 10);
    var configBalanceThresholdLargePositive = directDebit && parseInt(directDebit.balanceThresholdLargePositive, 10);
    if (directDebit &&
        !!configBalanceThresholdSmallPositive &&
        !!configBalanceThresholdLargePositive &&
        !isNaN(configBalanceThresholdSmallPositive) &&
        !isNaN(configBalanceThresholdLargePositive)) {
        if (configBalanceThresholdSmallPositive < configBalanceThresholdLargePositive) {
            balanceThresholdSmall = configBalanceThresholdSmallPositive;
            balanceThresholdLarge = configBalanceThresholdLargePositive;
        }
        else {
            console.warn('The small balance threshold is greater than the high balance threshold amount in energy provider config. The Direct Debit components are falling back to default values to prevent unexpected behaviour. Please check the docs for more info.');
        }
    }
    if (amount < (0, exports.getNegative)(balanceThresholdSmall) &&
        amount > (0, exports.getNegative)(balanceThresholdLarge)) {
        return 'smallDebt';
    }
    else if (amount <= (0, exports.getNegative)(balanceThresholdLarge)) {
        return 'largeDebt';
    }
    else if (amount >= balanceThresholdSmall) {
        return 'credit';
    }
    return 'onTrack';
};
exports.getPredictedFinalBalanceState = getPredictedFinalBalanceState;
var stripSpacesAndDashes = function (val) { return val.replace(/[\s-]/g, ''); };
exports.stripSpacesAndDashes = stripSpacesAndDashes;
